import { Input, Component, OnInit } from '@angular/core';
import { Validator, NG_VALIDATORS, NG_VALUE_ACCESSOR, ControlValueAccessor, FormGroup, ValidationErrors } from '@angular/forms';
import { SectionControlItem } from '@feature/_app_modules/additional-information/additional-information.types';
import { AbstractControl, ValidatorFn } from '@angular/forms';

@Component({
  selector: 'mojo-additional-information-admin-form',
  templateUrl: './additional-information-admin-form.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: AdditionalInformationAdminFormComponent
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: AdditionalInformationAdminFormComponent
    }
  ]
})
export class AdditionalInformationAdminFormComponent implements ControlValueAccessor, Validator, OnInit {

  constructor() { }

  validate(control: AbstractControl): ValidationErrors | null {
      return null;
  }

  @Input()
  sections: SectionControlItem[] = [];

  onTouched = () => { };
  onChange = (sections) => { };

  touched = false;

  disabled = false;

  noSectionsSelected() {
    return this.sections.every(s => s.Allowed === false) && this.sections.some(s => s.Default === false);
  }

  ngOnInit(): void {
  } 


  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  writeValue(value: SectionControlItem[]): void {
    this.sections = value;
  }

  registerOnChange(fn): void { this.onChange = fn; }

  registerOnTouched(fn): void { this.onTouched = fn; }

  additionalInfoAllowAllChecked(field) {
    return ( this.sections || [] ).every(r => r.Allowed);
  }

  additionalInfoDefaultAllChecked(field) {
    return (this.sections || []).every(r => r.Default);
  }

  handleAdditionalInfoAllowAllChange(evt) {
    try {
      (this.sections || []).forEach(x => x.Allowed = evt.target.checked);
      this.onChange(this.sections);
    } catch (e) {
      console.error(e);
    }
  }

  handleAdditionalInfoDefaultAllChange(evt) {
    try {
      (this.sections || []).forEach(r => r.Default = evt.target.checked);
      this.onChange(this.sections);
    } catch (e) {
      console.error(e);
    }
  }

}
